import React from "react";
import "./Various.css";
import Wrapper from "../components/basic/wrapper";
import various from "../assets/images/webp/various.webp";
import { useI18n } from "../i18n/i18n";
import SafeArea from "../components/basic/safe-area";
import { SeeMoreArrowSVG } from '../constants/svgs';

const Various: React.FC = () => {
    const sectionColor = "#ffffff";
    const sectionTextColor = "#FFFFFF";

    const { t } = useI18n();

    // preload both backgrounds once
    const usePreloadImages = (urls: string[]) => {
        React.useEffect(() => {
            urls.forEach((url) => {
                if (!url) return;
                const img = new Image();
                img.src = url;
            });
        }, [urls]);
    };
    usePreloadImages([various]);
    const seeMoreLabel = t('project.press.seeMore');
    const sectionLabel = t('varios.section');
    return (
        <>
            <div className="various-container-desktop">
                <Wrapper
                    color={sectionColor}
                    footerColor={sectionTextColor}
                    logoColor={sectionTextColor}
                >
                    <>
                        <div style={{ backgroundColor: sectionColor }}>
                            <div className="various-title" style={{ background: '#000000' }}>
                                <div className="various-p1" />
                                <div className="various-p2">
                                    <img src={various} alt="Various" style={{ height: 615 }} />
                                </div>
                                <div className="various-p3" />
                                <div className="various-p4">
                                    <div className="various-see-more">
                                        <div style={{ lineHeight: '26px' }} dangerouslySetInnerHTML={{ __html: sectionLabel }}></div>
                                        <br />
                                        <div>
                                            <a
                                                className="d-flex gap8 aic see_more_url"
                                                href="https://read.dukeupress.edu/theater/issue/53/2"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <div dangerouslySetInnerHTML={{ __html: seeMoreLabel }}></div>
                                            </a>
                                        </div>
                                    </div>
                                </div>
                                <div className="various-p5" />
                            </div>
                        </div>
                    </>
                </Wrapper>
            </div>
            <div className="various-container-mobile">
                <Wrapper
                    color={sectionColor}
                    hasFooter={false}
                    footerColor={sectionTextColor}
                    logoColor={sectionTextColor}
                >
                    <>
                        <div style={{ backgroundColor: sectionColor }}>
                            <div className="various-title-mobile" style={{ background: '#000000', paddingTop: 114, paddingBottom: 25 }}>
                                <img src={various} alt="Various" style={{ height: 543 }} />
                                <SafeArea>
                                    <div className="various-see-more-mobile">
                                        <div style={{ lineHeight: '26px' }} dangerouslySetInnerHTML={{ __html: sectionLabel }}></div>
                                        <br />
                                        <div>
                                            <a
                                                className="d-flex gap8 aic see_more_url"
                                                href="https://read.dukeupress.edu/theater/issue/53/2"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                            >
                                                <div dangerouslySetInnerHTML={{ __html: seeMoreLabel }}></div>
                                            </a>
                                        </div>
                                    </div>
                                </SafeArea>
                            </div>
                        </div>
                    </>
                </Wrapper>
            </div>
        </>
    );
};

export default Various;
